import type { TFunction } from 'i18next';
import type { PatientRoomPropertyResponse, PatientRoomResponse } from '../../api/generated';
import { getRoomNameColumn, getRoomNeedsColumn, getRowActionColumns } from '../UI';
import type { RoomEditingCallbacks, TableColumn } from '../UI';
import { ROOM_NAME_COLUMN_KEY } from './roomsConstants';
import columnStyles from './roomColumns.module.css';

interface RoomColumnCallbacks extends RoomEditingCallbacks<PatientRoomResponse> {
  allRoomProperties: PatientRoomPropertyResponse[];
}

export const getRoomColumns = (
  t: TFunction,
  cb: RoomColumnCallbacks
): TableColumn<PatientRoomResponse>[] => {
  const columns: TableColumn<PatientRoomResponse>[] = [
    getRoomNameColumn(cb, {
      key: ROOM_NAME_COLUMN_KEY,
      header: t('settings-col-room-name')
    }),
    getRoomNeedsColumn(cb, {
      header: t('settings-col-room-needs'),
      emptyLabel: t('room-need-no-results'),
      assignedProperties: (room) => room.patientRoomProperties,
      allProperties: cb.allRoomProperties
    })
  ];

  if (!cb.canWrite) return columns;

  return [...columns, ...getRowActionColumns(t, cb, columnStyles.actionIcon)];
};
